<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-text-field
          label="Email address"
          v-model="model.email"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Repeat email address"
          v-model="model.emailRepeat"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        You'll receive an email to set your password after pressing the button
        <em>Register</em>.
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: { value: Object },
  data() {
    return {
      model: {
        email: null,
        emailRepeat: null,
        password: null,
        passwordRepeat: null
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.model = val;
      }
    },
    model: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped></style>
